/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfsam_TypeInputs */

const en_pc_alt_t_pdfsam_type = /** @type {(inputs: Pc_Alt_T_Pdfsam_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop tool for page operations`)
};

const zh_pc_alt_t_pdfsam_type = /** @type {(inputs: Pc_Alt_T_Pdfsam_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理页面的桌面工具`)
};

/**
* | output |
* | --- |
* | "Desktop tool for page operations" |
*
* @param {Pc_Alt_T_Pdfsam_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfsam_type = /** @type {((inputs?: Pc_Alt_T_Pdfsam_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfsam_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfsam_type(inputs)
	return zh_pc_alt_t_pdfsam_type(inputs)
});
export { pc_alt_t_pdfsam_type as "pc.alt.t.pdfsam.type" }